module.exports = __webpack_public_path__ + "static/about-content-4-bd355ff3651591aece4b1dab2015cbf7.png";